module.exports = __webpack_public_path__ + "static/so-1-sq-46ac5ebf44bb1c2b54d4fd1d76dc2fbe.png";